import React from 'react'
import Section1 from './one/Section1'
import Section2 from './two/Section2'
import Section3 from "./Three/Section3"
import Section4 from './Four/Section4'
import Section5 from './Five/Section5'
import Section6 from './Six/Section6'

function Sections() {
  return (
    <>
        <Section1/>
        <Section2/>
        <Section3/>
        <Section4/>
        <Section5/>
        <Section6/>
    </>
  )
}

export default Sections